export default {
    EM_ELABORACAO: 'EM_ELABORACAO',
    NEGOCIACAO: 'NEGOCIACAO',
    FINALIZADO: 'FINALIZADO'
}
